/**
 * A tab container component.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright (c) Ircam Amplify 2025
 */
import { ReactNode, useState } from 'react'
import './styles/tab-container.css'

interface TabProps {
  title: string
  className: string
  isSelected: boolean
  onClick: () => void
}

const Tab = (props: TabProps) => {
  return (
    <div
      className={`
        ${props.className}
        ${props.isSelected ? 'selected' : 'unselected'}`}
      onClick={props.onClick} // Handle click
    >
      {props.title}
    </div>
  )
}

interface TabContainerProps {
  tabList: string[]
  children: ReactNode[] // Accepts multiple children, one for each tab
  customComp?: ReactNode
}

const TabContainer = (props: TabContainerProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0)

  return (
    <div className="tab-container">
      <div className="tab-bar">
        {props.tabList.map((tabTitle, index) => (
          <Tab
            className="tab"
            key={index}
            title={tabTitle}
            isSelected={selectedIndex === index}
            onClick={() => setSelectedIndex(index)} // Update selected tab
          />
        ))}

        {props.customComp && <>{props.customComp}</>}
      </div>

      {/* Display the corresponding content */}
      {props.children.length > selectedIndex && (
        <div className="tab-content">{props.children[selectedIndex]}</div>
      )}
    </div>
  )
}

export default TabContainer
